// extracted by mini-css-extract-plugin
module.exports = {"alignRight":"AlignRight_alignRight__3A9PN","vertical":"AlignRight_vertical__3Zk3u"};